<template>
  <v-dialog
    v-if="getDialog.directionSelect"
    v-model="getDialog.directionSelect"
    activator="parent"
    width="auto"
  >
    <div class="alert-common modal-content">
      <div class="modal-header">
        <h5 class="modal-title">SCREEN</h5>
        <button
          type="button"
          class="btn-close"
          @click="closeDialog()"
        ></button>
      </div>
      <div class="message-area modal-body">
        <div class="w-full flex justify-center text-white gap-4">
          <div class="direction-box w-1/2 flex flex-col justify-center items-center" :class="{ active: selectMode === 'vertical' }" @click="toggleSelectMode('vertical')">
            <div class="image-box flex items-center">
              <img class="vertical" src="@/assets/img/direction/vertical.png" alt="vertical">
            </div>
            <div class="text nixgonm">Vertical</div>
          </div>
          <div class="direction-box w-1/2 flex flex-col justify-center items-center" :class="{ active: selectMode === 'horizontal' }" @click="toggleSelectMode('horizontal')">
            <div class="image-box flex flex-col items-center justify-center">
              <img class="horizontal" src="@/assets/img/direction/horizontal.png" alt="horizontal">
              <div class="nixgonm info-text mt-1">Please disable<br>[Auto rotate]</div>
            </div>
            <div class="text nixgonm">Horizontal</div>
          </div>
        </div>
      </div>
      <div class="button-box flex justify-center ">
        <button class="image-button w-1/2" :disabled="!selectMode" @click="handleGame"  >
            SELECT
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import DialogMixin from "@/mixins/dialogMixin";
import MachineMixin from "@/mixins/machineMixin";
import EventBus from "@/utils/EventBus";

export default {
  mixins: [DialogMixin, MachineMixin],
  props: {},
  data() {
    return {
      selectMode: "",
      machine_id: null,
    };
  },

  computed: {},

  mounted() {
    EventBus.$on("directionSelect/machine_id", (machine_id) => {
      this.machine_id = machine_id;
    });
  },

  methods: {
    // 모달 닫기 이벤트 emit
    closeDialog() {
      this.setDialog("directionSelect", false);
    },
    toggleSelectMode(value) {
      if (this.selectMode === value) this.selectMode = "";
      else this.selectMode = value;
    },
    handleGame() {
      this.$cookies.set("direction", this.selectMode, 60 * 60 * 24);
      this.createMachinePlayer(this.machine_id);
      this.setMachineDirection(this.selectMode);
      this.setDialog("directionSelect", false);
    },
  },
};
</script>


<style lang="scss" scoped>
.modal-title{
font-size:2.5rem !important;
}
.modal-content{
  background-color:#23263F !important;
}

.direction-box {
  border-radius: 16px;
  background: #353748;
  height:220px;
  padding:14px;
  border:3px solid transparent;
  transition: all 0.2s ease;

  .text{
    color: #6E7294;
    text-align: center;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.60);
    font-size: 23px !important;
    font-weight: bold;
    line-height: normal;
  }
  .image-box{
    height:150px;
    .vertical{
      height:100%;
    }
    .horizontal{
      width:100%;
    }
    .info-text{
      text-align: center;
      color: #9398BE;
      font-size: 14px !important;
      font-weight: bold;
      line-height: normal;
    }
  }

  &.active{
    background-color:#293A54;
    border:3px solid #58DEFF;
    box-shadow: 0px 0px 12px rgba(88, 222, 255, 0.4);
    .text{
      color:#58DEFF;
    }
    .image-box{
      .info-text{
        color: #58DEFF;
      }
    }
  }
}
.button-box {
  border-top:3px solid #444A72;
  padding:15px;
}
</style>